module.exports = __webpack_public_path__ + "static/media/tequan2.250c815b.png";